import React from "react";

import { faBoxArchive, faCircleCheck, faTriangleExclamation } from "@performyard/fontawesome/pro-solid-svg-icons";
import type { MeetingStatus } from "@performyard/models";
import { Chip } from "@performyard/py-components";
import { BaseTopColors } from "@performyard/py-components/src/theme";

interface MeetingStatusBadgeProps {
	status: MeetingStatus;
}

const MeetingStatusBadge = ({ status }: MeetingStatusBadgeProps) => {
	const getStatusConfig = (status: MeetingStatus) => {
		switch (status) {
			case "completed":
				return {
					label: "Completed",
					color: "green",
					icon: faCircleCheck,
				};
			case "canceled":
				return {
					label: "Canceled",
					color: "red",
					icon: faTriangleExclamation,
				};
			case "archived":
				return {
					label: "Archived",
					color: "neutral",
					icon: faBoxArchive,
				};
			default:
				return null;
		}
	};

	const config = getStatusConfig(status);

	if (!config) {
		return null;
	}

	return (
		<Chip
			label={config.label}
			color={config.color as BaseTopColors}
			size={24}
			icon={config.icon}
			dangerouslySetClassName="w-[74px]"
		/>
	);
};

export default MeetingStatusBadge;
